import React, { useContext, useEffect } from "react";
import './sidebar.style.scss';
import lgoLogo from '../../../assets/SVG/LGO.svg';
import { AccountContext } from "../../../Contexts/main.context";
import locationIcon from '../../../assets/ICONS/documents-papers-with-text-lines-svgrepo-com.svg';
import notFoundIcon from '../../../assets/ICONS/not-found-16-svgrepo-com.svg';
import customerIcon from '../../../assets/ICONS/customer-source-line-svgrepo-com.svg';
import mapIcon from '../../../assets/ICONS/map-pin-svgrepo-com.svg';
import EditMapIcon from '../../../assets/ICONS/map-pin-alt-svgrepo-com.svg';
import accountIcon from '../../../assets/ICONS/sign-out-svgrepo-com.svg';
import editIcon from '../../../assets/ICONS/LGO_Edit.svg';
import addIcon from '../../../assets/ICONS/add-circle-svgrepo-com.svg';
import followIcon from '../../../assets/ICONS/search-globe-svgrepo-com.svg';
import changeIcon from '../../../assets/ICONS/request-added-svgrepo-com.svg';
import lgoGroup from '../../../assets/ICONS/LGO_Group.svg';
import createCitation from '../../../assets/ICONS/create_citation.svg';
import clients from '../../../assets/ICONS/clients.svg';


const SideBar = ({ width = "250px" }) => {

     const { actionButtons, updateActiveOutlet, myAccount, activeOutlet } = useContext(AccountContext)
     const [displayName, setDisplayName] = React.useState(null);


     useEffect(() => {
          setDisplayName(myAccount?.displayName || 'My Account');

     }, [myAccount]);



     const setTheSideButton = (inval) => {

          // If inval is a non-null object, do the object-specific logic
          if (typeof inval === 'object' && inval !== null && 'action' in inval) {
               const match = actionButtons?.find(el => el.action === inval.action);

               actionButtons?.forEach(element => {
                    element.selected = false;
               });

               if (match) {
                    match.selected = true;
               }

               updateActiveOutlet(inval.action); // use the object’s action
          } else {
               // If inval is just a string or not an object, pass it directly
               updateActiveOutlet(inval);
          }
     };

     const setBottomButton = (inval) => {
          actionButtons?.forEach(element => {
               element.selected = false;
          });
          updateActiveOutlet(inval);
     };

     const iconMap = (icon) => {
          switch (icon) {
               case 'locations': return locationIcon;
               case 'customer': return customerIcon;
               case 'map': return mapIcon;
               case 'edit': return EditMapIcon;
               case 'editCustomer': return editIcon;
               case 'add': return addIcon;
               case 'follow': return followIcon;
               case 'change': return changeIcon;
               case 'createCitation': return createCitation;
               default: return notFoundIcon;
          }
     };

     return (
          <div className="sidebar-wrapper" style={{ width: width }}>
               <div className="bg-navy w-100 text-center" style={{ height: "70px" }}>
                    <img
                         src={lgoLogo}
                         style={{ maxHeight: "45px", marginBottom: "15px", marginTop: "10px" }}
                         alt="LGO Logo"
                    />
               </div>

               {actionButtons && actionButtons.length > 0 &&
                    actionButtons
                         .filter(btn => !['followUp', 'changeLog'].includes(btn.action))
                         .filter(btn => myAccount?.security === 'Admin' || btn.permission === 'All')
                         .map((btn, index) => (
                              <div className="col-48" key={index}>
                                   <div onClick={() => setTheSideButton(btn)}
                                        className={`action-button d-flex align-items-center w-100 text-center py-3 ${btn.selected ? 'bg-warning' : ''}`}>

                                        <div className="col-14 text-center">
                                             <img
                                                  src={iconMap(btn.icon) || notFoundIcon}
                                                  alt={btn.icon}
                                                  height="35px"
                                             />
                                        </div>
                                        <div className="flex-grow-1 text-start">
                                             {btn.label}
                                        </div>
                                   </div>
                              </div>
                         ))
               }

               <div className="bottom-box w-100">
                    {myAccount.security === 'Admin' && (
                         <>
                              <div className={`bottom-button text-dark w-100 d-flex align-items-center ${activeOutlet === 'Users' || activeOutlet === 'updateUser' ? 'bg-warning text-light' : 'bg-light'}`} onClick={() => setBottomButton('Users')}>
                                   <div className="col-14">
                                        <img src={lgoGroup} alt="" height="35px" />
                                   </div>
                                   <div className="flex-grow-1 text-start">
                                        Manage Users
                                   </div>
                              </div>
                              <div className={`bottom-button text-dark w-100 d-flex align-items-center ${activeOutlet === 'Clients' || activeOutlet === 'Clients' ? 'bg-warning text-light' : 'bg-light'}`} onClick={() => setBottomButton('Clients')}>
                                   <div className="col-14">
                                        <img src={clients} alt="" height="35px" />
                                   </div>
                                   <div className="flex-grow-1 text-start">
                                        Manage Clients
                                   </div>
                              </div>
                         </>
                    )}
                    <div className={`bottom-button  w-100 d-flex align-items-center ${activeOutlet === 'Account' || activeOutlet === 'EditAccount' ? 'bg-warning text-navy' : 'bg-navy text-warning fw-bold'}`} onClick={() => setBottomButton('EditAccount')}>
                         <div className="col-14">
                              <img src={accountIcon} alt="" height="35px" />
                         </div>
                         <div className="flex-grow-1 text-start">
                              {displayName}
                         </div>
                    </div>

               </div>
          </div>
     );


}

export default SideBar;
